import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Settings, Shield, LogOut, X } from 'lucide-react';
import cacheStorage from '../../utils/cacheStorage';

export function AdminProfileFlyout({ isOpen, onClose, userName, userInitial, userPicture, onPrivacyClick }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
      <>
        <div
            className={`profile-flyout-overlay ${isOpen ? 'open' : ''}`}
            onClick={onClose}
        />
        <div className={`profile-flyout-panel ${isOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          <div className="profile-flyout-header">
            <span className="profile-flyout-title">Profile</span>
            <button onClick={onClose} className="profile-flyout-close">
              <X size={18} />
            </button>
          </div>

          <div className="profile-flyout-user-section">
            <div className="profile-flyout-avatar">
              {userPicture ? (
                  <img src={userPicture} alt={userName} className="profile-flyout-avatar-img" />
              ) : (
                  userInitial
              )}
            </div>
            <div className="profile-flyout-user-details">
              <div className="profile-flyout-signed-in">Signed in as:</div>
              <div className="profile-flyout-email">
                {userName}
              </div>
              <span className="profile-flyout-badge">Admin</span>
            </div>
          </div>

          <div className="profile-flyout-menu">
            <div className="profile-flyout-item" onClick={() => { onClose(); navigate('/admin/profile'); }}>
              <User size={18} className="profile-flyout-icon" />
              <span>My Profile</span>
            </div>
            <div className="profile-flyout-item" onClick={() => { onClose(); navigate('/admin/settings'); }}>
              <Settings size={18} className="profile-flyout-icon" />
              <span>Settings</span>
            </div>
            <div className="profile-flyout-item" onClick={() => { onClose(); onPrivacyClick(); }}>
              <Shield size={18} className="profile-flyout-icon" />
              <span>Privacy &amp; Policy</span>
            </div>
          </div>

          <div className="profile-flyout-logout-section">
            <div className="profile-flyout-logout" onClick={() => {
              cacheStorage.removeItem('access_token');
              cacheStorage.removeItem('id_token');
              cacheStorage.removeItem('user_picture');
              cacheStorage.removeItem("user_phone");
              cacheStorage.removeItem('user_name');

              onClose();
              navigate('/login', { replace: true });
            }}>
              <LogOut size={18} color="#DC2626" />
              <span>Logout</span>
            </div>
          </div>
        </div>
      </>
  );
}